import CustomModal from 'components/global/CustomModal'
import useFormSubmit from 'helper/Hooks/formSubmit'
import React from 'react'
import { manageTeamStore } from 'state/league/manageTeam'
import DiscountForm from './ModalContent/DiscountForm'
import CustomModalFooter from 'components/global/CustomModalFooter'

const AddDiscountModal: React.FC = () => {
  const { form, handleSubmit } = useFormSubmit()
  const { addDiscountModal, setAddDiscountModal, setSelectedDiscount } =
    manageTeamStore(store => ({
      addDiscountModal: store.addDiscountModal,
      setAddDiscountModal: store.setAddDiscountModal,
      setSelectedDiscount: store.setSelectedDiscount,
    }))

  const closeModal = () => {
    setSelectedDiscount(null)
    setAddDiscountModal(false)
  }

  return (
    <>
      <CustomModal
        openModal={addDiscountModal}
        isCloseModalCustom={true}
        closeModal={closeModal}
        title="Add Discount"
        footer={
          <CustomModalFooter
            multibutton={true}
            btnAlignment="justify-end"
            btnText="Cancel,Save"
            onSubmit={handleSubmit}
            closeModal={closeModal}
          />
        }
      >
        <DiscountForm form={form} />
      </CustomModal>
    </>
  )
}

export default AddDiscountModal
